(function ($) {

    'use strict';

    var suppressDeliveryScroll = false;
    var suppressFallback = null;

    /**
     * Store the original jQuery animate function.
     */
    var originalAnimate = $.fn.animate;

    /**
     * Block scroll animations while switching
     * delivery/collection methods.
     */
    $.fn.animate = function () {

        var properties = arguments[0];

        if (
            suppressDeliveryScroll &&
            properties &&
            typeof properties === 'object' &&
            typeof properties.scrollTop !== 'undefined'
        ) {
            // log for debugging
            // console.log(
            //     '[Delivery] Prevented WooCommerce scroll:',
            //     properties.scrollTop
            // );

            return this;
        }

        return originalAnimate.apply(
            this,
            arguments
        );

    };

    /**
     * Start suppressing scroll when the user
     * changes delivery method.
     */
    $(document).on(
        'mousedown',
        '.delivery-buttons__button',
        function () {

            suppressDeliveryScroll = true;

            /**
             * Stop any scroll animation already running.
             */
            $('html, body').stop(true, false);

            /**
             * Safety fallback only.
             */
            window.clearTimeout(
                suppressFallback
            );

            suppressFallback =
                window.setTimeout(
                    function () {

                        suppressDeliveryScroll = false;

                    },
                    10000
                );

        }
    );

    /**
     * All jQuery AJAX requests have completed.
     *
     * Keep suppression active very briefly because
     * WooCommerce can run completion handlers at the
     * end of the AJAX lifecycle.
     */
    $(document).ajaxStop(function () {

        if (!suppressDeliveryScroll) {
            return;
        }

        window.setTimeout(
            function () {

                suppressDeliveryScroll = false;

                window.clearTimeout(
                    suppressFallback
                );

            },
            250
        );

    });

})(jQuery);